// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"175":"6ca7ccb6","311":"7bc63c4a"}[chunkId] + ".chunk.css";
};